/*
 * XYNE Redesign — Ingredients overview page
 * Filter (category chips), search (live name + botanical match), sort (A-Z, Z-A,
 * by category, by product count). Pure DOM manipulation — no rerender.
 */
(function () {
  'use strict';

  function init() {
    var page = document.querySelector('[data-rd-ing-pg]');
    if (!page) return;

    var grid = page.querySelector('[data-rd-ing-grid]');
    var cards = Array.prototype.slice.call(page.querySelectorAll('[data-rd-ing-card]'));
    var chips = Array.prototype.slice.call(page.querySelectorAll('[data-rd-ing-chip]'));
    var productChips = Array.prototype.slice.call(page.querySelectorAll('[data-rd-ing-product-chip]'));
    var searchInput = page.querySelector('[data-rd-ing-search]');
    var sortSelect = page.querySelector('[data-rd-ing-sort]');
    var summaryEl = page.querySelector('[data-rd-ing-summary]');
    var summaryText = page.querySelector('[data-rd-ing-summary-text]');
    var emptyEl = page.querySelector('[data-rd-ing-empty]');
    var clearBtns = Array.prototype.slice.call(page.querySelectorAll('[data-rd-ing-clear]'));

    var state = {
      category: 'all',
      product: 'all',
      query: '',
      sort: 'az'
    };

    // Map handle → product title for the active-filter summary chip text
    var productTitleMap = {};
    productChips.forEach(function (chip) {
      var h = chip.dataset.rdIngProductChip;
      if (!h || h === 'all') return;
      // The chip's text content is "Title <span>count</span>" — strip the span
      var clone = chip.cloneNode(true);
      var span = clone.querySelector('.rd-ing-pg__chip-count');
      if (span) span.parentNode.removeChild(span);
      productTitleMap[h] = (clone.textContent || '').trim();
    });

    // Cache the original DOM order so we can restore "default" after sorting
    cards.forEach(function (card, idx) {
      card.dataset.rdIngOriginalOrder = String(idx);
    });

    // Category-priority map for "by category" sort
    var CATEGORY_ORDER = { energy: 0, recovery: 1, gut: 2, balance: 3, universal: 4 };

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (card) {
        var cat = card.dataset.rdIngCategory || 'universal';
        var name = card.dataset.rdIngName || '';
        var botanical = card.dataset.rdIngBotanical || '';
        // products is a normalized comma list (no spaces) of product handles
        var products = card.dataset.rdIngProducts || '';

        var matchCategory = state.category === 'all' || cat === state.category;
        // Per-product match: state.product appears as a CSV item. Bracket the
        // search with commas so "energy-strips" doesn't false-match "energy-strips-pm".
        var matchProduct = state.product === 'all' ||
          (',' + products + ',').indexOf(',' + state.product + ',') >= 0;
        var matchSearch = !state.query ||
          name.indexOf(state.query) >= 0 ||
          botanical.indexOf(state.query) >= 0;

        if (matchCategory && matchProduct && matchSearch) {
          card.removeAttribute('data-rd-ing-hidden');
          visible++;
        } else {
          card.setAttribute('data-rd-ing-hidden', '');
        }
      });

      // Empty state
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (grid) grid.hidden = visible === 0;

      // Summary bar
      if (summaryEl) {
        var hasFilter = state.category !== 'all' || state.product !== 'all' || state.query.length > 0;
        if (hasFilter && visible > 0) {
          summaryEl.hidden = false;
          var bits = [];
          bits.push('<strong>' + visible + '</strong> ' + (visible === 1 ? 'ingredient' : 'ingredients'));
          if (state.category !== 'all') {
            bits.push('in <strong>' + capitalize(state.category) + '</strong>');
          }
          if (state.product !== 'all') {
            var productLabel = productTitleMap[state.product] || state.product;
            bits.push('found in <strong>' + escapeHtml(productLabel) + '</strong>');
          }
          if (state.query) {
            bits.push('matching "<strong>' + escapeHtml(state.query) + '</strong>"');
          }
          if (summaryText) summaryText.innerHTML = bits.join(' ');
        } else {
          summaryEl.hidden = true;
        }
      }
    }

    function applySort() {
      if (!grid) return;
      var sorted = cards.slice();

      if (state.sort === 'az') {
        sorted.sort(function (a, b) {
          return (a.dataset.rdIngName || '').localeCompare(b.dataset.rdIngName || '');
        });
      } else if (state.sort === 'za') {
        sorted.sort(function (a, b) {
          return (b.dataset.rdIngName || '').localeCompare(a.dataset.rdIngName || '');
        });
      } else if (state.sort === 'category') {
        sorted.sort(function (a, b) {
          var oa = CATEGORY_ORDER[a.dataset.rdIngCategory] || 99;
          var ob = CATEGORY_ORDER[b.dataset.rdIngCategory] || 99;
          if (oa !== ob) return oa - ob;
          return (a.dataset.rdIngName || '').localeCompare(b.dataset.rdIngName || '');
        });
      } else if (state.sort === 'products') {
        sorted.sort(function (a, b) {
          var ca = parseInt(a.dataset.rdIngProductCount || '0', 10);
          var cb = parseInt(b.dataset.rdIngProductCount || '0', 10);
          if (ca !== cb) return cb - ca;
          return (a.dataset.rdIngName || '').localeCompare(b.dataset.rdIngName || '');
        });
      }

      // Re-append in sorted order — DOM rearrangement is cheap for 16-30 cards
      sorted.forEach(function (card) { grid.appendChild(card); });
    }

    function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
    function escapeHtml(s) {
      var div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }

    // ---------- Wire category chips ----------
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var cat = chip.dataset.rdIngChip;
        if (!cat) return;
        state.category = cat;
        chips.forEach(function (c) { c.setAttribute('aria-selected', String(c === chip)); });
        applyFilters();
      });
    });

    // ---------- Wire per-product chips (#34) ----------
    productChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var handle = chip.dataset.rdIngProductChip;
        if (!handle) return;
        state.product = handle;
        productChips.forEach(function (c) { c.setAttribute('aria-selected', String(c === chip)); });
        applyFilters();
      });
    });

    // ---------- Wire search (debounced 80ms) ----------
    if (searchInput) {
      var searchTimer = null;
      searchInput.addEventListener('input', function () {
        if (searchTimer) clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          state.query = searchInput.value.trim().toLowerCase();
          applyFilters();
        }, 80);
      });
    }

    // ---------- Wire sort ----------
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        applySort();
      });
    }

    // ---------- Wire clear-all buttons ----------
    clearBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = 'all';
        state.product = 'all';
        state.query = '';
        chips.forEach(function (c) { c.setAttribute('aria-selected', String(c.dataset.rdIngChip === 'all')); });
        productChips.forEach(function (c) { c.setAttribute('aria-selected', String(c.dataset.rdIngProductChip === 'all')); });
        if (searchInput) searchInput.value = '';
        applyFilters();
        // Scroll to grid for mobile users
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // ---------- Card expand/collapse ----------
    // Cards default to compact (header only). Click toggles to
    // expanded (full body visible + scaled up). Clicking a different
    // card auto-collapses the previously-expanded one so the page
    // stays clean. Inner anchors (research link, product chips)
    // bubble normally — they navigate, they don't toggle. (#87)
    cards.forEach(function (card) {
      function toggle(e) {
        // Let inner anchor / chip clicks navigate without toggling.
        var t = e.target;
        if (t.closest('a') && t.closest('a') !== card) return;
        var isExpanded = card.getAttribute('aria-expanded') === 'true';
        // Collapse all other cards (one-at-a-time pattern keeps the
        // page tidy — no stack of expanded cards).
        cards.forEach(function (other) {
          if (other !== card) other.setAttribute('aria-expanded', 'false');
        });
        card.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        e.preventDefault();
      }
      card.addEventListener('click', toggle);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
        if (e.key === 'Escape' && card.getAttribute('aria-expanded') === 'true') {
          card.setAttribute('aria-expanded', 'false');
          card.blur();
        }
      });
    });

    // Initial apply (in case URL hash or other state seeded the filters)
    applySort();
    applyFilters();

    // ---------- URL hash deep-linking ----------
    // #category-energy → activates the energy category chip
    // #product-bone-support-strips → activates that product chip (#34)
    function handleHash() {
      var hash = window.location.hash.replace(/^#/, '');
      if (hash.indexOf('category-') === 0) {
        var cat = hash.slice('category-'.length);
        var matchingChip = chips.find(function (c) { return c.dataset.rdIngChip === cat; });
        if (matchingChip) matchingChip.click();
      } else if (hash.indexOf('product-') === 0) {
        var handle = hash.slice('product-'.length);
        var matchingProduct = productChips.find(function (c) { return c.dataset.rdIngProductChip === handle; });
        if (matchingProduct) matchingProduct.click();
      }
    }
    handleHash();
    window.addEventListener('hashchange', handleHash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
